import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import Reveal from "@/components/site/Reveal";

const QUOTES = [
  {
    quote: "Sarah has a gift for seeing what others miss. Her strategies helped us increase bookings and finally feel in control of our business — without the chaos we used to live in.",
    name: "Jessica M.",
    role: "Airbnb Investor",
    location: "Nashville, TN",
    context: "Revenue Leak Audit · 2 properties",
    img: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=200&q=80",
  },
  {
    quote: "Working with Sarah felt like exhaling. She brought structure to operations that had been quietly draining us — and our numbers reflect it. The clarity was the unexpected gift.",
    name: "Daniel R.",
    role: "Portfolio Owner",
    location: "Asheville, NC",
    context: "Strategy Intensive · 4-door portfolio",
    img: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=200&q=80",
  },
  {
    quote: "She doesn't sell hype. She asks better questions, notices the small things, and helps you make decisions you can actually stand behind. Calm, considered, and quietly transformative.",
    name: "Renee K.",
    role: "STR Operator",
    location: "Charleston, SC",
    context: "Monthly Advisory · ongoing",
    img: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&w=200&q=80",
  },
];

export default function Testimonials() {
  const [i, setI] = useState(0);
  const next = () => setI((i + 1) % QUOTES.length);
  const prev = () => setI((i - 1 + QUOTES.length) % QUOTES.length);
  const q = QUOTES[i];

  return (
    <section data-testid="home-testimonials" className="pt-14 lg:pt-16 pb-28 lg:pb-36 bg-cream">
      <div className="container-editorial">
        <Reveal>
          {/* Grounded section header — single emotional focal point */}
          <div className="text-center max-w-2xl mx-auto mb-20">
            <p className="font-ui uppercase tracking-[0.22em] text-[14px] font-semibold text-sage mb-6">
              Kind Words From Clients
            </p>
            <p className="font-sans text-charcoal/70 text-base md:text-[17px] leading-[1.7]">
              What clients tend to feel afterward — calmer, clearer, more confident.
            </p>
          </div>
        </Reveal>

        <Reveal delay={120}>
          <div className="max-w-5xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
              <button
                onClick={prev}
                data-testid="testimonial-prev"
                aria-label="Previous"
                className="hidden lg:flex lg:col-span-1 w-11 h-11 rounded-full border border-warmGray/40 items-center justify-center text-navy hover:bg-navy hover:text-ivory transition-all"
              >
                <ChevronLeft className="w-4 h-4" />
              </button>

              <div className="lg:col-span-7 text-center lg:text-left">
                <span className="font-serif text-gold text-7xl leading-none block mb-2 -ml-1">"</span>
                <p data-testid="testimonial-quote" className="font-serif italic text-[1.55rem] md:text-[1.95rem] lg:text-[2.15rem] text-navy leading-[1.4]">
                  {q.quote}
                </p>
              </div>

              <div className="lg:col-span-3 flex items-center gap-4 justify-center lg:justify-start lg:flex-col lg:items-start" data-testid="testimonial-author">
                <img src={q.img} alt={q.name} className="w-16 h-16 rounded-full object-cover ring-1 ring-warmGray/30" />
                <div>
                  <p className="font-ui uppercase tracking-[0.16em] text-[12.5px] font-semibold text-navy">— {q.name}</p>
                  <p className="font-sans text-[15px] text-charcoal/75 mt-1.5">{q.role}</p>
                  <p className="font-sans text-[14px] text-charcoal/55">{q.location}</p>
                  <span className="block w-10 h-px bg-gold my-4" />
                  <p className="font-ui uppercase tracking-[0.14em] text-[12px] font-semibold text-sage">{q.context}</p>
                </div>
              </div>

              <button
                onClick={next}
                data-testid="testimonial-next"
                aria-label="Next"
                className="hidden lg:flex lg:col-span-1 w-11 h-11 rounded-full border border-warmGray/40 items-center justify-center text-navy hover:bg-navy hover:text-ivory transition-all"
              >
                <ChevronRight className="w-4 h-4" />
              </button>
            </div>

            <div className="flex justify-center gap-2 mt-14">
              {QUOTES.map((_, idx) => (
                <button
                  key={idx}
                  onClick={() => setI(idx)}
                  data-testid={`testimonial-dot-${idx}`}
                  aria-label={`Go to testimonial ${idx + 1}`}
                  className={`h-px transition-all duration-500 ${idx === i ? "w-16 bg-navy" : "w-8 bg-warmGray/40"}`}
                />
              ))}
            </div>
          </div>
        </Reveal>

        <p className="font-ui text-center text-[12px] tracking-[0.18em] uppercase font-medium text-charcoal/55 mt-14">
          Sample testimonials — to be replaced with real client stories.
        </p>
      </div>
    </section>
  );
}
